module.exports = __webpack_public_path__ + "img/TCC-L4-Pagina1 A.da3c9d42.png";